export default {
  formulario: {
    emitente: {
      id: null,
      tipo: 2,
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      cpf: '',
      inscricao_municipal: '',
      inscricao_estadual: '',
      regime_tributario: '',
      incentivador_cultural: false,
      optante_simples_nacional: false,
      iss_retido: false,
      possui_cadastro_fiscal: false,
      status_sincronizacao: null,
      mensagem_sincronizacao: null
    },

    servico: {
      codigo_issqn: '',
      cnae: '',
      regime_especial: '0'
    },

    endereco: {
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      municipio: '',
      uf: '',
      codigo_ibge: ''
    },

    contato: {
      telefone: '',
      email: ''
    },

    tributos: {
      federais: '',
      estaduais: '',
      municipais: ''
    },

    configuracoes: {
      cpf_cnpj_contabilidade: '',
      senha_certificado: '',
      logotipo_url: null,
      possui_logotipo: false,
      recibo_danfe: true,
      exibe_sempre_ipi_danfe: true,
      exibe_issqn_danfe: true,
      exibe_impostos_adicionais_danfe: true,
      exibe_rastro_danfe: true,
      exibe_unidade_tributaria_danfe: true,
      exibe_sempre_volumes_danfe: false,
      ativo: true,
      habilita_nfsen_producao: false,
      habilita_nfsen_homologacao: true
    },

    responsavel: {
      nome_responsavel: '',
      cpf_responsavel: '',
      login_responsavel: '',
      senha_responsavel: '',
      senha_responsavel_preenchida: false
    }
  },

  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    }
  }
}
